<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
          <b-button
            v-if="$can('read','users')"
            variant="info"
            :disabled="excelSpinner"
            @click="downloadExcel"
          >
            <b-spinner
              v-if="excelSpinner"
              small
            />
            {{ $t('Download excel') }}
            <feather-icon icon="FileTextIcon" />
          </b-button>
          <b-button
            v-if="$can('create','users')"
            variant="success"
            class="ml-1"
            @click="createButtonClicked"
          >
            {{ $t('Create user') }}
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <users-list
      v-else
      :fields="fields"
      :items="items"
      :sort-key="sortKey"
      :sort-type="sortType"
      :additional-data="additionalData"
      :list-filters="additionalData.filters"
      :filters="filters"
      @onSortByChange="changeSortKey"
      @onSortDescChange="changeSortType"
      @onFilterChange="filterChange"
      @onFilterButtonClicked="getData"
      @onDeleteButtonClicked="deleteButtonClicked"
    />

    <list-pagination
      :current="page"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import store from '@/store'
import { ListIndex } from '../../../common/mixins/list'
import UsersList from '../../../components/admin/users/list/UsersList'

export default {
  components: {
    UsersList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'users',
      sortKey: 'created_at',
      sortType: true,
      adminFields: [
        {
          key: 'id',
          label: this.$t('Id'),
          sortable: true,
        },
        {
          key: 'name',
          label: this.$t('Name'),
        },
        {
          key: 'mobile',
          label: this.$t('Mobile'),
        },
        {
          key: 'roles',
          label: this.$t('Roles'),
        },
        {
          key: 'email',
          label: this.$t('Email'),
        },
        {
          key: 'status',
          label: this.$t('Status'),
        },
        {
          key: 'created_at',
          label: this.$t('Created at'),
          sortable: true,
        },
      ],
    }
  },
  computed: {
    appConfig() {
      return store.state.app.appConfig
    },
  },
  created() {
    if (!this.appConfig.reseller) {
      this.adminFields.push({
        key: 'source',
        label: this.$t('Source'),
      })
    }
    this.adminFields.push({
      key: 'action',
      label: '',
    })
  },
}
</script>

<style lang="scss">

</style>
